export const environment = {
  production: true,
  authUrl: 'https://auth.api.ums.1minutepourmoncoeur.fr',
  apiUrl: 'https://api.ums.1minutepourmoncoeur.fr/1.0',
  psp: 'https://ums.1minutepourmoncoeur.fr',
  psa: 'https://alerts.ums.1minutepourmoncoeur.fr',
  pscActive: true,
  pscToken:
    'https://auth.bas.psc.esante.gouv.fr/auth/realms/esante-wallet/protocol/openid-connect/token',
  pscAuth: 'https://wallet.bas.psc.esante.gouv.fr/auth/',
  pscRedirectUri: 'https://auth.ums.1minutepourmoncoeur.fr/pscAuth',
  pscClientId: 'newcard-newcard-bas',
  pscClientSecret: 'a91b7ded-0715-456f-9c18-48c08a2e7a7b',

  newcardURL: 'https://(alerts.)?ums.1minutepourmoncoeur.fr.*',
  cookieDomain: '.1minutepourmoncoeur.fr',
};
